import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  apiUrl = '/api/user/';
  user = {
    id: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    role: '',
    image: '',
    gender: ''
  };

  isAdmin() {
    if (isPlatformBrowser(this.platformId)) {

      return localStorage.getItem('role') === 'Admin';
    }
  }

  isCrm() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('role') === 'CRM';
    }
  }

  isUser() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('role') === 'User';
    }
  }

  getRole() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('role').toLowerCase();
    }
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient) {
  }

  saveUser(data: any): void {
    if (isPlatformBrowser(this.platformId)) {

      localStorage.setItem('id', data.id);
      localStorage.setItem('first_name', data.first_name);
      localStorage.setItem('last_name', data.last_name);
      localStorage.setItem('phone_number', data.phone_number);
      localStorage.setItem('role', data.role);
      localStorage.setItem('image', data.image);
      localStorage.setItem('gender', data.gender);
    }
  }

  getUser(): any {
    if (isPlatformBrowser(this.platformId)) {

      this.user = {
        id: localStorage.getItem('id'),
        first_name: localStorage.getItem('first_name'),
        last_name: localStorage.getItem('last_name'),
        phone_number: localStorage.getItem('phone_number'),
        role: localStorage.getItem('role'),
        image: localStorage.getItem('image'),
        gender: localStorage.getItem('gender')
      };
    }
    return this.user;
  }

  deleteUser(): void {
    if (isPlatformBrowser(this.platformId)) {

      localStorage.removeItem('id');
      localStorage.removeItem('first_name');
      localStorage.removeItem('last_name');
      localStorage.removeItem('phone_number');
      localStorage.removeItem('role');
      localStorage.removeItem('image');
      localStorage.removeItem('gender');
    }
  }

  fetchUser(): Promise<any> {
    return this.http.get(this.apiUrl + 'get_profile').toPromise().then((res: any) => {
      this.user = res;
      this.saveUser(res);
    });
  }


}
